module.exports = __webpack_public_path__ + "img/light_bulb.f614a658.gif";